import { createStyles, makeStyles, Theme } from "@material-ui/core";

export default makeStyles((theme: Theme) =>
  createStyles({
    closeButton: {
      position: "absolute",
      right: theme.spacing(1),
      top: theme.spacing(1),
      color: theme.palette.grey[500]
    },
    field: {
      display: "flex",
      justifyContent: "center",
      marginBottom: theme.spacing(2)
    },
    fieldInline: {
      display: "flex",
      marginBottom: theme.spacing(2),
      [theme.breakpoints.up("md")]: {
        display: "inline-flex",
        marginRight: theme.spacing(2),
        width: "30%"
      }
    }
  })
);
